import { useI18n } from '../context/I18nContext';

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="app-footer">
      <div>{t('footer')}</div>
      <div style={{ marginTop: '4px', opacity: 0.7 }}>{t('poweredBy')}</div>
    </footer>
  );
}
